import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"
import "@rails/activestorage"
import "flowbite/dist/flowbite.turbo.js";
import 'flowbite';